import { request } from "../utils/api";

export const GetMe = () => {
  return request({
    method: "get",
    baseUrl: "api",
    route: "participant",
  });
};
